import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { HouseholdStudent } from '@k12/models';
import { SHARED_ENVIRONMENT } from '@k12/environment';
import { Observable } from 'rxjs';

export interface Student {
  esaFundingLevel: string;
  firstName: string;
  grade?: string;
  id: string;
  iepVerified: boolean;
  iepVerifiedDate?: string;
  certificationDate?: string;
  isFoster?: boolean;
  lastName: string;
  middleName?: string;
  personId: string;
  pidNumber?: string;
  prefix?: string;
  studentId: string;
}

@Injectable({
  providedIn: 'root'
})
export class StudentsService {
  private readonly http: HttpClient = inject(HttpClient);
  private readonly sharedEnvironment = inject(SHARED_ENVIRONMENT);
  private readonly apiUrl = this.sharedEnvironment.adminApiUrl;

  public getStudentDetails(id: string | null): Observable<Student> {
    return this.http.get<Student>(`${this.apiUrl}/household/student/${id}`);
  }

  getStudentsByHouseholdId(householdId: string): Observable<HouseholdStudent[]> {
    const params = new HttpParams().set('householdId', householdId);
    return this.http.get<HouseholdStudent[]>(`${this.apiUrl}/household/students`, { params });
  }
}
